import React from 'react';

const Footer = () => {
    return (
        <div className="text-center mt-4 m-5">
          <small>Designed and Developed by MD Sofie Uddin Sohel, 2021</small>
        </div>
    );
};

export default Footer;